import {FC} from 'react';
import {useRouteError} from 'react-router-dom';

import NotFoundError from '../../ui/not-found/NotFoundError';

import styles from './ErrorPage.module.scss';

const ErrorPage: FC = () => {
  const error = useRouteError();
  console.error(error);

  return (
    <div className={styles.wrapper}>
      <NotFoundError />
    </div>
  );
};

export default ErrorPage;
